﻿import $ from "jquery";

function setupConfirmMessages(parentSelector) {
    $(parentSelector || '[data-confirm-message]').each(setupConfirmMessage);
}

function setupConfirmMessage() {
    let formAttr = $(this).attr('data-confirm-message-for');
    let buttonAttr = $(this).attr('data-confirm-message-button');
    let confirmText = $(this).text();

    $(`[${formAttr}]`).on('submit', function (event, _data) {
        let submitButton = $(event.originalEvent.submitter);
        if (submitButton.is(`[${buttonAttr}]`)) {
            if (!confirm(confirmText)) {
                submitButton.closest(`[${formAttr}]`).find('button').removeClass('disabled disabled--current');
                event.preventDefault();
            }
        }
    });
}

export default setupConfirmMessages;